export default theme => ({
  content: {
    margin: '40px 0 50px 0',
  }
});
